<template>
  <div>
    <PageHeaderLayout :isBack="true">
      <div class="main-page-content">
        <el-row class="steps">
          <el-col :span="24">
            <el-steps
              :active="active"
              align-center
              simple
              finish-status="success"
            >
              <el-step
                v-for="item in steps"
                :key="item.title"
                :title="item.title"
                :description="item.description"
              />
            </el-steps>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-select v-model="value" placeholder="请选择" size="medium" class="address-select">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button type="primary" size="medium" class="manage-bill-btn" @click="manageBill">管理开票信息</el-button>
        </el-row> -->
          <el-alert
            class="alert"
            title="请确保开票信息无误，如有更改请及时修改或联系客服人员"
            type="warning"
            show-icon
            :closable="false">
          </el-alert>
          <el-form ref="form" :model="form" label-width="100px" :rules="rules" class="bill-info-form" :label-position="'top'">
            <el-row>
              <el-col :span="12">
                <div class="bill-info">
                  <el-form-item prop="invoice_title">
                    <template slot="label">
                      <div class="bill-info-title">企业名称</div>
                    </template>
                    <el-input v-model="form.invoice_title" :disabled="disabled"/>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="bill-info">
                  <el-form-item prop="company_phone">
                    <template slot="label">
                      <div class="bill-info-title">企业电话</div>
                    </template>
                    <el-input v-model="form.company_phone" :disabled="disabled"/>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div class="bill-info">
                  <el-form-item prop="taxpayer">
                    <template slot="label">
                      <div class="bill-info-title">企业税号</div>
                    </template>
                    <el-input v-model="form.taxpayer" :disabled="disabled"/>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="bill-info">
                  <el-form-item prop="company_bank">
                    <template slot="label">
                      <div class="bill-info-title">开户行</div>
                    </template>
                    <el-input v-model="form.company_bank" :disabled="disabled"/>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div class="bill-info">
                  <el-form-item prop="company_address">
                    <template slot="label">
                      <div class="bill-info-title">企业地址</div>
                    </template>
                    <el-input v-model="form.company_address" :disabled="disabled"/>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="bill-info">
                  <el-form-item prop="company_account">
                    <template slot="label">
                      <div class="bill-info-title">银行账号</div>
                    </template>
                    <el-input v-model="form.company_account" :disabled="disabled"/>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <div v-for="(item, index) in form.category" :key="index" class="fenge">
              <el-row>
                <el-col :span="12">
                  <div class="bill-info">
                    <el-form-item
                      :prop="'category.'+ index + '.category_id'"
                      :rules="{
                        required: true, message: '请输入开票类目', trigger: 'blur'
                      }"
                    >
                      <template slot="label">
                        <div class="bill-info-title">开票类目</div>
                      </template>
                      <el-select v-model="item.category_id" :disabled="disabled" @change="selectCatory" placeholder="请选择开票类目" style="width: 100%" >
                        <el-option
                          v-for="i in options1"
                          :key="i.category_id"
                          :label="i.display_name"
                          :value="i.category_id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="bill-info">
                    <el-form-item
                      :prop="'category.'+ index + '.category_money'"
                      :rules="{
                        required: true, message: '请输入申请开票金额', trigger: 'blur'
                      }"
                    >
                      <template slot="label">
                        <div class="bill-info-title">开票金额</div>
                      </template>
                      <div class="business-address">
                        <el-input v-model="item.category_money" :disabled="disabled"/><i class="iconfont iconiconmoney priceIcon"></i>
                        <!-- <i class="el-icon-circle-plus-outline icon" @click="addClick"></i><i class="el-icon-remove-outline icon" @click="deleteClick(index)" v-if="index != 0"></i> -->
                      </div>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </div>

            <el-row>
              <el-col :span="12">
                <div class="bill-info">
                  <el-form-item prop="invoice_type">
                    <template slot="label">
                      <div class="bill-info-title">开票类型</div>
                    </template>
                    <el-select v-model="form.invoice_type" :disabled="disabled" placeholder="请选择开票类型" style="width: 100%">
                      <el-option
                        v-for="item in this.options2"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="bill-info">
                  <el-form-item prop="remark">
                    <template slot="label">
                      <div class="bill-info-title">发票右下角备注信息</div>
                    </template>
                    <el-input v-model="form.remark" :disabled="disabled"/>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <div class="bill-mail-info">
                <el-form-item prop="receiver_address">
                  <template slot="label">
                    <div class="mail-info-title">收件地址：</div>
                  </template>
                  <el-input v-model="form.receiver_address" :disabled="disabled"/>
                </el-form-item>
                <el-form-item prop="receiver_fullname">
                  <template slot="label">
                    <div class="mail-info-title">收件人：</div>
                  </template>
                  <el-input v-model="form.receiver_fullname" :disabled="disabled"/>
                </el-form-item>
                <el-form-item prop="receiver_phone">
                  <template slot="label">
                    <div class="mail-info-title">收件人电话：</div>
                  </template>
                  <el-input v-model="form.receiver_phone" :disabled="disabled"/>
                </el-form-item>
              </div>
            </el-row>
          </el-form>
          <el-row class="save-btn-wrapper">
            <el-button type="primary" size="medium" @click="saveClick('form')" v-if="this.$route.query.save">保存</el-button>
            <el-button type="primary" size="medium" @click="toReview()" v-if="this.$route.query.review">复核</el-button>
          </el-row>
      </div>
    </PageHeaderLayout>
    <ModalDialog :dialogData="toReviewDialogData" @dialogConfirm="toReviewHandleConfirm" @dialogClose="toReviewDialogClose" :showButton="showButton">
        <template slot="content">
          <el-form :model="toReviewRuleForm" ref="toReviewRuleForm" class="demo-ruleForm" :label-position="'right'" >
            <el-form-item>
              <el-radio-group v-model="toReviewRuleForm.invoice_status" @change="selectRadio">
                <el-radio label="3">通过</el-radio>
                <el-radio label="5">驳回</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="toReviewRuleForm.invoice_status == 5">
              <el-input type="textarea" :rows="4" v-model="toReviewRuleForm.review_remark" placeholder="请输入驳回原因"></el-input>
            </el-form-item>
          </el-form>
        </template>
      </ModalDialog>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ModalDialog from '@/components/ModalDialog'
export default {
  components: {
    PageHeaderLayout,
    ModalDialog
  },
  watch: {
    "toReviewRuleForm.invoice_status": function(val) {
      if(val) {
        this.toReviewDialogData.loading = false
      }else {
        this.toReviewDialogData.loading = true
      }
    },
  },
  data() {
    return {
      showButton: ['cancel'],
      options1: [],
      options2: [{
        label: "普通发票",
        value: 0,
      },
      {
        label: "增值税专用发票",
        value: 1,
      }],
      active: 1,
      steps: [
        {
          title: "申请开票",
          description: "",
          content: "step1",
        },
        {
          title: "平台审批",
          description: "",
          content: "step2",
        },
        {
          title: "发票开出",
          description: "",
          content: "step3",
        },
        {
          title: "发票寄出",
          description: "",
          content: "step4",
        },
      ],
      options: [
        {
          value: "选项1",
          label:
            "企业名称：福建省贵全信息咨询有限公司 企业银行: 中国建设银行股份有限公司晋江分行 邮件地址：浙江省，杭州市，余杭区，欧美金融城3901室",
        },
        {
          value: "选项2",
          label:
            "企业名称：福建省贵全信息咨询有限公司 企业银行: 中国建设银行股份有限公司晋江分行 邮件地址：浙江省，杭州市，余杭区，欧美金融城3901室",
        },
        {
          value: "选项3",
          label:
            "企业名称：福建省贵全信息咨询有限公司 企业银行: 中国建设银行股份有限公司晋江分行 邮件地址：浙江省，杭州市，余杭区，欧美金融城3901室",
        },
        {
          value: "选项4",
          label:
            "企业名称：福建省贵全信息咨询有限公司 企业银行: 中国建设银行股份有限公司晋江分行 邮件地址：浙江省，杭州市，余杭区，欧美金融城3901室",
        },
        {
          value: "选项5",
          label:
            "企业名称：福建省贵全信息咨询有限公司 企业银行: 中国建设银行股份有限公司晋江分行 邮件地址：浙江省，杭州市，余杭区，欧美金融城3901室",
        },
      ],
      value: "",
      form: {
        invoice_title: '',
        company_account: '',
        taxpayer: '',
        company_bank: '',
        company_address: '',
        remark: '',
        company_phone: '',
        receiver_address: '',
        receiver_fullname: '',
        receiver_phone: '',
        category:[
          {
            category_id: '',
            category_money: '',
          },
        ],
        invoice_type: ''
      },
      rules: {
        invoice_title: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        company_account: [
          { required: true, message: '请输入银行账号', trigger: 'blur' }
        ],
        taxpayer: [
          { required: true, message: '请输入企业税号', trigger: 'blur' }
        ],
        company_bank: [
          { required: true, message: '请输入开户行', trigger: 'blur' }
        ],
        company_address: [
          { required: true, message: '请输入企业地址', trigger: 'blur' }
        ],
        // remark: [
        //   { required: true, message: '请输入备注', trigger: 'blur' }
        // ],
        company_phone: [
          { required: true, message: '请输入企业电话', trigger: 'blur' },
          // { min:5, max:11, message: '请输入5到11位手机号', trigger: 'blur' }
        ],
        receiver_address: [
          { required: true, message: '请输入收件地址', trigger: 'blur' }
        ],
        receiver_fullname: [
          { required: true, message: '请输入收件人', trigger: 'blur' }
        ],
        receiver_phone: [
          { required: true, message: '请输入收件人电话', trigger: 'blur' },
          { min:11, message: '请输入11位手机号', trigger: 'blur' }
        ],
        invoice_type: [
          { required: true, message: '请选择开票类型', trigger: 'blur' }
        ]
      },
      disabled: false,
      toReviewRuleForm: {
        id: '',
        invoice_status: '',
        review_remark: ''
      },
      toReviewDialogData: {
        visible: false,
        title: '',
        width: '40%',
        loading: true,
        modal: false
      },
    };
  },
  methods: {
    //增加一条数据
    addClick() {
      let item = {
        category_id: this.form.category.category_id,
        category_money: this.form.category.category_money
      }
      this.form.category.push(item)
    },
    //删除一条数据
    deleteClick(index) {
      this.form.category.splice(index, 1)
    },
    //复核
    toReview() {
      this.toReviewRuleForm.id = this.$route.query.id
      this.toReviewDialogData.title = `复核${this.$route.query.id}`
      this.toReviewDialogData.visible = true
    },
    // 处理复核模态框，确定事件
    toReviewHandleConfirm() {
      // 调用组件的数据验证方法
      this.toReviewData();
      this.toReviewRuleForm = {}
      this.toReviewDialogData.visible = false
    },
    // 处理复核模态框，关闭事件
    toReviewDialogClose() {
      this.toReviewRuleForm = {}
      this.toReviewDialogData.visible = false
    },
    //选择复核状态
    selectRadio() {
      if(this.toReviewRuleForm.invoice_status == 3) {
        this.toReviewRuleForm.review_remark = ''
      }
    },
    //复核操作
    async toReviewData() {
      let result = await this.$api.toReview(this.toReviewRuleForm)
      if(result) {
        this.$message.success('复核成功')
      }else {
        this.$message.error('复核失败')
      }
      this.$router.push({path:'/invoice'})
    },
    // 管理开票信息
    manageBill() {
      console.log("管理开票信息")
    },
    // 保存
    saveClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.$route.query.id) {
            this.editInvoice()
          }else {
            this.formSubmit()
          }
        } else {
          this.$message.warning('请先正确填写信息');
          return false;
        }
      });
    },
    //保存表单
    async formSubmit() {
      const args = {
        invoice_type: this.form.invoice_type,
        invoice_title: this.form.invoice_title,
        category: JSON.stringify(this.form.category),
        taxpayer: this.form.taxpayer,
        company_bank: this.form.company_bank,
        company_account: this.form.company_account,
        company_address: this.form.company_address,
        company_phone: this.form.company_phone,
        receiver_fullname: this.form.receiver_fullname,
        receiver_address: this.form.receiver_address,
        remark: this.form.remark,
        receiver_phone: this.form.receiver_phone
      }
      let result = await this.$api.createInvoiceList(args)
      if(result) {
        this.$message.success('保存成功')
        this.$router.push({path:'/invoice'})
      }else {
        this.$message.error('保存失败，请稍后重试');
      }
    },
    //获取开票类目
    async getInvoiceCategory() {
      let result = await this.$api.getInvoiceCategory()
      if(result) {
        this.options1 = result
      }
    },
    selectCatory() {
      console.log("selectCatory",this.form.category.category_id)
    },
    //编辑开票
    async editInvoice() {
      const args = {
        invoice_type: this.form.invoice_type,
        invoice_title: this.form.invoice_title,
        category: JSON.stringify(this.form.category),
        taxpayer: this.form.taxpayer,
        company_bank: this.form.company_bank,
        company_account: this.form.company_account,
        company_address: this.form.company_address,
        company_phone: this.form.company_phone,
        receiver_fullname: this.form.receiver_fullname,
        receiver_address: this.form.receiver_address,
        remark: this.form.remark,
        receiver_phone: this.form.receiver_phone,
        id: this.$route.query.id
      }
      console.log(args,this.form,"args")
      let result = await this.$api.editInvoice(args)
      if(result) {
        this.$message.success('保存成功')
        this.$router.push({path:'/invoice'})
      }else {
        this.$message.error('保存失败，请稍后重试');
      }
    },
    async companyInit(id) {
      let result = await this.$api.getCompanyInfo(id)
      if(result) {
        if(result.info.name) {
          this.form.invoice_title = result.info.name
        }
        if(result.info.account) {
          this.form.company_account = result.info.account
        }
        if(result.info.taxpayer){
          this.form.taxpayer = result.info.taxpayer
        }
        if(result.info.bank) {
          this.form.company_bank = result.info.bank
        }
        if(result.info.address) {
          this.form.company_address = result.info.address
        }
        if(result.info.receiver_fullname) {
          this.form.receiver_fullname = result.info.receiver_fullname
        }
        if(result.info.receiver_phone) {
          this.form.receiver_phone = result.info.receiver_phone
        }
        if(result.info.email) {
          this.form.receiver_address = result.info.email
        }
        if(result.info.company_phone) {
          this.form.company_phone = result.info.company_phone
        }
      }
    },
    //获取开票详情
    async invoiceDetail(id) {
      let args = {id: id}
      let result = await this.$api.getInvoiceView(args)
      if(result) {
        this.$message.success('获取数据成功')
        this.form = result
        this.form.category = result.category_list
        if(result.invoice_type) {
          if(result.invoice_type == 0) {
            this.form.invoice_type = '普通发票'
          }
          if(result.invoice_type == 1) {
            this.form.invoice_type = '增值税专用发票'
          }
        }
        if(result.status == 0) {
          this.active = 1
        }
        if(result.status == 1) {
          this.active = 2
        }
        if(result.status == 2) {
          if(result.invoice_status == 1) {
            this.active = 2
          }
          if(result.invoice_status == 2) {
            this.active = 3
          }
          if(result.invoice_status == 3) {
            this.active = 3
          }
          if(result.invoice_status == 4) {
            this.active = 4
          }
          if(result.invoice_status == 5) {
            this.active = 3
          }
        }
        if(result.status == 3) {
          this.active = 2
        }
      }else {
        this.$message.error('获取数据失败')
      }
    }
  },
  mounted() {
    this.companyInit(this.mxCompanyId)
    this.getInvoiceCategory()
    if(this.$route.query.id) {
      this.invoiceDetail(this.$route.query.id)
    }
    this.disabled = this.$route.query.disabled
  },
};
</script>

<style lang="stylus" scoped>
  .address-select
    width: 85%
  .manage-bill-btn
    margin-left: 20px
  .bill-info-form
    margin-top: 40px
  .bill-info
    display: flex
    flex-direction: column
    width: 90%
    height: 80px
    padding: 20px 0
  .bill-info-title
    width:100%
  .bill-mail-info
    width: 70%
    max-width: 600px;
    margin: 0px auto
    margin-top: 40px
    padding: 0 25%
    padding-top: 50px
    padding-bottom: 20px
    border-top: 1px solid #dcdfe6
    border-bottom: 1px solid #dcdfe6
  /deep/.bill-mail-info .el-form-item
    display: flex
    flex-direction: row
  /deep/.el-form--label-top .el-form-item__label
    position: relative
  /deep/.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before,
  /deep/.el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap > .el-form-item__label:before
    position: absolute
    left: -10px
  /deep/.bill-mail-info .el-form-item .el-form-item__content
    width: 100%
  .mail-info-title
    width: 100px
  .business-address
    display: flex
  .save-btn-wrapper
    display: flex
    justify-content: flex-end
    margin-top: 30px
    margin-bottom: 30px
  .priceIcon
    font-size: 30px
    color: #e6a23c
    margin-top: 3px
    margin-left: 10px
  .alert
    margin-top: 40px
  /deep/.steps .el-steps--simple
    background: #fff
    padding: 13px 0%;
  /deep/.steps .el-steps--simple .el-step__title
    width: 80%
    text-align: center
    height: 40px
    line-height: 40px
    padding: 0 10px
    background: #959595
    color: #fff
  /deep/ .steps .el-step.is-simple:not(:last-of-type) .el-step__title
    max-width: 80%
  /deep/.steps .el-step__head
    display: none
  /deep/.steps .el-steps--simple .el-step__title.is-success
    background: #00B79E
  .icon
    font-size: 30px
  .fenge
    border-top: 1px solid #dcdfe6
    margin-top: 50px
    padding-top: 30px
    width: 99%

</style>






